import { render, staticRenderFns } from "./AddOrUpdateEducationModal.vue?vue&type=template&id=569f0668"
import script from "./AddOrUpdateEducationModal.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateEducationModal.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateEducationModal.vue?vue&type=style&index=0&id=569f0668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports